import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'atx-pagination-loader',
  templateUrl: './pagination-loader.component.html',
  styleUrls: ['./pagination-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaginationLoaderComponent {
  @Input()
  public allLoaded = false;

  @Input()
  public nonEmpty = true;

  @Input()
  public total = 0;

  @Input()
  public loading = true;
}
